const Footer = () => {
  return <div className="h-5"></div>;
};

export default Footer;
